import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Breadcrumb } from 'antd'
import { crumbsFor } from '../../sections'

const AppBreadcrumb: React.FC = () => {
    const { pathname } = useLocation()
    const crumbs = crumbsFor(pathname)
    if (crumbs.length === 0) return null

    return (
        <Breadcrumb className="app-breadcrumb">
            {crumbs.map((crumb, index) => (
                <Breadcrumb.Item key={index}>{crumb.to ? <Link to={crumb.to}>{crumb.label}</Link> : crumb.label}</Breadcrumb.Item>
            ))}
        </Breadcrumb>
    )
}

export default AppBreadcrumb
